// removed by extract-text-webpack-plugin
module.exports = {"fm-stag-sans-light":"main__fm-stag-sans-light___3zr22"};


//////////////////
// WEBPACK FOOTER
// ./src/theme/enterprise/main.scss
// module id = 1042
// module chunks = 0